// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as CustomerExistsApiModel$PorterinFeature from "../api-model/CustomerExistsApiModel.mjs";

function apiModelToState(model) {
  return {
          status: model.exists
        };
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(CustomerExistsApiModel$PorterinFeature.t_decode(json), "CustomerExistsEntityMapper.res");
  return {
          status: model.exists
        };
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
